<template>
  <q-pull-to-refresh @refresh="refresh">
    <router-view />
  </q-pull-to-refresh>
</template>
<script>
import { defineComponent, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { LocalStorage } from "quasar";

export default defineComponent({
  name: "App",
  setup() {
    const store = useStore();
    const currentDomain = window.location.hostname;
    let intervalId = null;
    store.dispatch("core/getAllStocks");
    store.dispatch("core/latestFiscalYearQuarter");
    store.dispatch("domain/domain", currentDomain);
    LocalStorage.set("stateDomains", store.state.domain);
    LocalStorage.set("isSignup", false);
    if (store.state.authenticate.isAuthenticated)
      store.dispatch("packages/getPackageStatus");

    store.dispatch("market/marketStatusNew");
    function refresh(done) {
      setTimeout(() => {
        done();
        window.location.reload();
      }, 1000);
    }

    onMounted(() => {
      intervalId = setInterval(() => {
        store.dispatch("market/marketStatusNew");
        if (!store.state.market?.marketStatus) clearInterval(intervalId);
      }, 10000);
    });

    onUnmounted(() => {
      clearInterval(intervalId);
    });

    return {
      store,
      refresh,
    };
  },
});
</script>
